import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class EvolucaoServico extends Servico {
  constructor() {
    super('evolucao')
  }

  adicionarProntuario(dados) {
    store.setCarregando()
    return axios
      .post(`${URL}/prontuario`, dados)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarDiario(prontuarioId, diario) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/${prontuarioId}/diario`, diario)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarDiario(prontuarioId, diario) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${prontuarioId}/diario`, diario)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  removerDiario(prontuarioId, diario) {
    store.setCarregando()
    return axios
      .delete(`${URL}/${this.path}/${prontuarioId}/diario`, {
        data: { _id: diario._id },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarEspecialidadesComAgendamentos(pacienteId) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/especialidades`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperaAgendamentosNaEspecialidade(pacienteId, especialidade) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/agendamentos`, {
        params: { especialidade },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperaGuiasPorEspecialidade(pacienteId, especialidade) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/guias`, {
        params: { especialidade: especialidade },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarRespostas(agendamentoId) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/respostas`, {
        params: { agendamento_id: agendamentoId },
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarResposta(prontuarioId, resposta) {
    store.setCarregando()
    return axios
      .post(`${URL}/prontuario/${prontuarioId}/resposta`, resposta)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarResposta(prontuarioId, respostaId, resposta) {
    store.setCarregando()
    return axios
      .put(`${URL}/prontuario/${prontuarioId}/resposta/${respostaId}`, {
        resposta: resposta.resposta,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarFormulariosEmEvolucaoPaciente(pacienteId) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${pacienteId}/formularios`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default EvolucaoServico
